import { type Ref, onBeforeUnmount, onMounted, ref } from 'vue'

interface UseClickOutsideOptions {
	excludeSelectors?: string[]
	closeOnScroll?: boolean
}

export function useClickOutside(
	show: Ref<boolean>,
	targetRef: Ref<HTMLElement | null>,
	options: UseClickOutsideOptions = {},
) {
	const {
		excludeSelectors = ['.filter-toggle-button'],
		closeOnScroll = true,
	} = options

	function closeOnClickOutside(e: Event) {
		if (
			show.value
			&& targetRef.value
			&& !targetRef.value.contains(e.target as Node)
		) {
			// Vérifier si le clic provient d'un élément à exclure
			const target = e.target as HTMLElement
			const shouldExclude = excludeSelectors.some(selector =>
				target.closest(selector),
			)

			if (!shouldExclude) {
				show.value = false
			}
		}
	}

	function closeOnScrollHandler() {
		if (show.value) {
			show.value = false
		}
	}

	onMounted(() => {
		document.addEventListener('click', closeOnClickOutside)

		if (closeOnScroll) {
			document.addEventListener('scroll', closeOnScrollHandler, true)
		}
	})

	onBeforeUnmount(() => {
		document.removeEventListener('click', closeOnClickOutside)

		if (closeOnScroll) {
			document.removeEventListener('scroll', closeOnScrollHandler, true)
		}
	})

	return {
		closeOnClickOutside,
		closeOnScrollHandler,
	}
}
